import { MUser } from '@Models/auth.model'
import { connect } from 'react-redux'
import { useHistory } from 'react-router'
import * as Redux from 'redux'
import AuthAction from '../../store/auth/auth.action'
import './Header.scss'

interface IHeader {
    logout: () => void
    user?: MUser
}

function Header(props: IHeader) {
    // core section
    const { logout, user } = props
    const history = useHistory()

    // functions section
    const handleLogout = () => {
        logout()
        history.push('/login')
    }
    return (
        <div className="header-layout">
            <div className="logo-container">
                <img
                    className="logo"
                    src={require('../../assets/images/logo.png').default}
                    alt=""
                />
            </div>
            <p className="brand-name">SECURE FIREARMS PLATFORM</p>
            <span>
                {user?.permissions?.length ? (
                    <span className="logout" onClick={handleLogout}>
                        <span className="logout-text font-montserrat">
                            Log Out
                        </span>
                        <img
                            src={
                                require('../../assets/images/icons/logout.png')
                                    .default
                            }
                            alt=""
                        />
                    </span>
                ) : null}
            </span>
            <div className="ribbon" />
        </div>
    )
}

// store section
const mapStateToProps = (state: any) => {
    const { user } = state?.auth
    return { user }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const { logout } = AuthAction
    return {
        logout: () => dispatch(logout() as any),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
